// Route guard for /admin/* and /merchant/* subtrees.
// Behavior:
//   - while AuthProvider is still bootstrapping, render a tiny placeholder
//     instead of bouncing the user (prevents flash-of-login on refresh)
//   - if logged out → /login
//   - if logged in but wrong role → /dashboard (their normal home)
//   - if right role → render children

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RequireRole({ roles, children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>Loading…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  const allowed = Array.isArray(roles) ? roles : [roles];
  // Admins implicitly satisfy every role check (super-set access).
  const effective = user?.is_staff || user?.is_superuser ? 'admin' : user?.role || 'customer';
  if (!allowed.includes(effective)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
